export interface SopoAlertSettings {
    doNotCloseOnClear?: boolean;
    header?: string;
    subHeader?: string;
    message?: string;
    dismissAfter?: number;
    backdropDismiss?: boolean;
    buttonText?: string;
    buttonHandler?: Function;
    sCss?: string[];
    zIndex?: number;
    preventAutoDismiss?: boolean;
    isGameContainer?: boolean;
}

export const DEFAULT_SOPO_ALERT_SETTINGS: SopoAlertSettings = {
    doNotCloseOnClear: false,
    header: '',
    subHeader: '',
    message: '',
    dismissAfter: 0,
    backdropDismiss: true,
    buttonText: '',
    buttonHandler: () => {},
    sCss: [],
    zIndex: 0,
    preventAutoDismiss: false,
    isGameContainer: false,
}
